"use client";

import { c as _c } from "react/compiler-runtime";
import type { ApiWaveCuration } from "@/generated/models/ApiWaveCuration";
import { commonApiFetch } from "@/services/api/common-api";
import { useQuery } from "@tanstack/react-query";
export interface DropCurationMembership extends ApiWaveCuration {
  readonly drop_included: boolean;
  readonly authenticated_user_can_curate: boolean;
}
export const getDropCurationsQueryKey = (dropId: string) => ["drop-curations", {
  drop_id: dropId
}] as const;
export function useDropCurations(t0) {
  const $ = _c(8);
  const {
    dropId,
    enabled: t1
  } = t0;
  const enabled = t1 === undefined ? true : t1;
  let t2;
  if ($[0] !== dropId) {
    t2 = getDropCurationsQueryKey(dropId);
    $[0] = dropId;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== dropId) {
    t3 = async () => await commonApiFetch({
      endpoint: `drops/${dropId}/curations`
    });
    $[2] = dropId;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const t4 = enabled && !!dropId;
  let t5;
  if ($[4] !== t2 || $[5] !== t3 || $[6] !== t4) {
    t5 = {
      queryKey: t2,
      queryFn: t3,
      enabled: t4,
      staleTime: 60000
    };
    $[4] = t2;
    $[5] = t3;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  return useQuery(t5);
}